import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import '../assets/scss/main.scss'

import Header from '../components/header'
import Newsletter from '../components/newsletter'
import Footer from '../components/footer'

const Layout = ({ children, location }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
        wp {
          siteOptions {
            settings {
              menu {
                link
                text
              }
              openingHours {
                days
                open {
                  label
                  time
                }
                close {
                  label
                  time
                }
                closed
              }
              hours {
                days
                hours
              }
            }
          }
        }
      }
    `}
    render={data => {
      return (
        <>
          <Header {...data} />
          <main>{ children }</main>
          <Newsletter />
          <Footer {...data} />
        </>
      )
    }
    }
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
